<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="PrinterConfig"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :readonly="resource.locked"
      :labelAlign="$config.forms.defaultLabelAlign"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpRow>
        <ItpCol>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="uri"
            :label="config.uri.label"
            :helpTooltip="config.uri.help"
            :required="config.uri.required"
          >
            <ItpFormInput
              name="uri"
              v-model="editor.uri"
              :required="config.uri.required"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="proxy"
            :label="config.proxy.label"
            :helpTooltip="config.proxy.help"
            :required="config.proxy.required"
          >
            <ItpFormInput
              name="proxy"
              v-model="editor.proxy"
              :required="config.proxy.required"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="name"
            :label="config.name.label"
            :helpTooltip="config.name.help"
            :required="config.name.required"
          >
            <ItpFormInput
              name="name"
              v-model="editor.name"
              :required="config.name.required"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="ipp_user_name"
            :label="config.ipp_user_name.label"
            :helpTooltip="config.ipp_user_name.help"
            :required="config.ipp_user_name.required"
          >
            <ItpFormInput
              name="ipp_user_name"
              v-model="editor.ipp_user_name"
              :required="config.ipp_user_name.required"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="2"
            name="ipp_version"
            :label="config.ipp_version.label"
            :helpTooltip="config.ipp_version.help"
            :required="config.ipp_version.required"
          >
            <ItpFormSelect
              name="ipp_version"
              v-model="editor.ipp_version"
              :options="IPPVersions"
              :required="config.ipp_version.required"
            >
            </ItpFormSelect>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="is_default"
            :label="config.is_default.label"
            :helpTooltip="config.is_default.help"
          >
            <ItpFormCheckbox
              name="is_default"
              v-model="editor.is_default"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
        </ItpCol>
      </ItpRow>
    </ItpForm>
    <hr
      v-if="!resource.isNew"
    >
    </hr>
    <PrinterTester
      :printerId="resource.id"
      v-if="!resource.isNew"
    >
    </PrinterTester>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Delete'|pgettext('Button')"
      variant="danger"
      icon="fa-times"
      :spinning="actions.delete.isRunning"
      class="mr-auto"
      v-if="!resource.isNew"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :form="forms[formName] && forms[formName].id"
      :text="'Save'|pgettext('Button')"
      type="submit"
      variant="primary"
      default
      :spinning="actions.submit && actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('Button')"
      variant="default"
      :disabled="actions.submit && actions.submit.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class PrinterConfig extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  IPPVersions!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  config!: any;
  resource!: any;

  async $$load_resource() {
    return this.oid
      ? this.$fn.fetch('get_object_by_type', { parameters: { id: this.oid, object_type: 'printer' }, asResource: true })
      : new this.$fn.Resource(
        _.reduce(this.$data.config, (m, v, k) => _.set(m, k, _.get(v, 'default', null)))
      )
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  selectedFile!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['IPPVersions', 'formId', 'formName', 'config', 'resource', 'editor', 'selectedFile', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        IPPVersions: ["1.0"
          ,
          "1.1"
          ,
          "2.0"
          ,
          "2.1"
          ,
          "2.2"
          ,
        ]
        ,
        formId: null,
        formName: "PrinterConfig",
        config: {
          name: {
            label: this.$fn.pgettext("PrinterConfig", "Printer Name"),
            help: this.$fn.pgettext("PrinterConfig", "A friendly name for the printer to help identify it easily."),
          }
          ,
          uri: {
            label: this.$fn.pgettext("PrinterConfig", "Printer URI"),
            help: this.$fn.pgettext("PrinterConfig", "The network address of the printer (e.g., ipp://printer.local:631/printers/Office). Must be a valid URL."),
            required: true,
          }
          ,
          proxy: {
            label: this.$fn.pgettext("PrinterConfig", "Proxy"),
            help: this.$fn.pgettext("PrinterConfig", "The URL of the proxy server, if any."),
          }
          ,
          ipp_user_name: {
            label: this.$fn.pgettext("PrinterConfig", "IPP User Name"),
            help: this.$fn.pgettext("PrinterConfig", "The username used for IPP (Internet Printing Protocol) authentication."),
            required: true,
          }
          ,
          ipp_version: {
            label: this.$fn.pgettext("PrinterConfig", "IPP Version"),
            help: this.$fn.pgettext("PrinterConfig", "Specifies the IPP protocol version used for communication (default is 2.0)."),
            required: true,
            default: "2.0",
          }
          ,
          is_default: {
            label: this.$fn.pgettext("PrinterConfig", "Set as Default Printer"),
            help: this.$fn.pgettext("PrinterConfig", "Mark this printer as the default option for print jobs."),
          }
          ,
        }
        ,
        resource: null,
        editor: null,
        selectedFile: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("PrinterConfig|Title", "Printer configuration")
          ,
        ]
        ,
        icon: this.$config.settings.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5086_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5086, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_5092_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_5092, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_5090_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_5090, alias=save
    return {
      objectType: "object_by_type",
      op: "upsert",
      data: { ...this.editor.getData(), 'object_type': 'printer' },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeModal_5096_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1548630417156826_closeModal_5096, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1548630417156826_request_5094_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_5094, alias=delete
    return {
      operation: "delete_object_by_type",
      data: this.resource.getData({ fields: ['id', 'etag'] }),
      parameters: {
        object_type: "printer",
      }
      ,
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_5098_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_5098, alias=undefined
    return {
      name: this.modalName,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5086: actions.CloseModalAction;
    evh_7315092382398562_close_5085: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_5088: actions.CloseComponentAction;
    evh_2248226175642056_close_5087: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_5092: actions.CloseModalAction;
    evh_1040167445267876_success_5091: actions.EventHandlerImpl;
    act_1040167445267876_crud_5090: actions.CRUDAction;
    evh_1040167445267876_submit_5089: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_5096: actions.CloseModalAction;
    evh_1548630417156826_success_5095: actions.EventHandlerImpl;
    act_1548630417156826_request_5094: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_5093: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_5098: actions.CloseModalAction;
    evh_2186679009640457_clickPreventStop_5097: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5086 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5086_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5085 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5086,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5085],
      }
    );
    const act_2248226175642056_closeComponent_5088 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5087 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_5088,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5087],
      }
    );
    const act_1040167445267876_closeModal_5092 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_5092_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5091 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_5092,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_5090 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_5090_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_5091],
      }
    );
    const evh_1040167445267876_submit_5089 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_5090,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5089],
      }
    );
    const act_1548630417156826_closeModal_5096 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1548630417156826_closeModal_5096_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_5095 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_5096,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1548630417156826_request_5094 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_5094_getActionArgs,
        displayName: "delete",
        events: [evh_1548630417156826_success_5095],
      }
    );
    const evh_1548630417156826_clickPreventStop_5093 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_5094,
        event: "click.prevent.stop",
        displayName: "delete",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_5093],
      }
    );
    const act_2186679009640457_closeModal_5098 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_5098_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_5097 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_5098,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_5097],
      }
    );
    return {
      act_7315092382398562_closeModal_5086,
      evh_7315092382398562_close_5085,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_5088,
      evh_2248226175642056_close_5087,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_5092,
      evh_1040167445267876_success_5091,
      act_1040167445267876_crud_5090,
      evh_1040167445267876_submit_5089,
      evh_1040167445267876_submit,
      act_1548630417156826_closeModal_5096,
      evh_1548630417156826_success_5095,
      act_1548630417156826_request_5094,
      evh_1548630417156826_clickPreventStop_5093,
      evh_1548630417156826_clickPreventStop,
      act_2186679009640457_closeModal_5098,
      evh_2186679009640457_clickPreventStop_5097,
      evh_2186679009640457_clickPreventStop,
      save: act_1040167445267876_crud_5090,
      delete: act_1548630417156826_request_5094,
    }
  }
}

Vue.component("PrinterConfig", PrinterConfig);

</script>